import type React from 'react';

import { IconButton, Input, InputAdornment, type InputProps } from '@mui/material';

import ClearIcon from 'assets/icons/icn _ 16px _close invert.svg?react';
import SearchIcon from 'assets/icons/search.svg?react';

import { useStyles } from './styles';

export type TMXInputProps = Omit<InputProps, 'inputRef'> & {
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onClear?: () => void;
  value?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
};

const SearchInput: React.FC<React.PropsWithChildren<TMXInputProps>> = ({ onChange, onClear, value, ...props }) => {
  const { classes } = useStyles();
  return (
    <Input
      disableUnderline
      classes={{ root: classes.root }}
      className={classes.input}
      endAdornment={
        (props.inputRef ? !!props.inputRef?.current?.value?.length : value !== '') && (
          <InputAdornment position="end">
            <IconButton disableRipple className={classes.clearIcon} size="large" onClick={onClear}>
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        )
      }
      startAdornment={
        <InputAdornment position="end">
          <IconButton disableRipple className={classes.searchIcon} size="large">
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      }
      value={value}
      onChange={onChange}
      {...props}
    />
  );
};

export default SearchInput;
